export const environment = {
  production: true,
  // version: '1.14.0',
  version: require('../../package.json').version,
  AGM_API_KEY: 'AIzaSyDiFMbTxMTyO9s9wijQ9fq28yCQTd3Hckg'
};
